import { AsyncThunkPayloadCreator, createAsyncThunk } from "@reduxjs/toolkit"
import { RootState } from "./types"

export type ThunkApiConfig = {
  state: RootState
  rejectValue: { code: number; message: string }
}

export function createAsyncAppThunk<Returned, ThunkArg = void>(
  typePrefix: string,
  payloadCreator: AsyncThunkPayloadCreator<Returned, ThunkArg, ThunkApiConfig>
) {
  return createAsyncThunk<Returned, ThunkArg, ThunkApiConfig>(
    typePrefix,
    payloadCreator
  )
}
